module.exports = __webpack_public_path__ + "img/comment-arrow-up.8af79e3e.svg";